<template>
  <div class="tab-icon-text-wrapper">
    <template v-if="iconDoneRightPlace">
      <div class="tab-header-layout">
        <div class="tab-header-copy">
          <p class="icon-text-heading" v-bind:class="{'inactive': textSubHeading && textSubHeading.length === 0}" @click="handleTabHeaderClick(tab)">
            <template v-if="tab && tab.showPaging">
              <span>{{ tab.textHeading }}</span>
            </template>
            <template v-else>
              <span>{{ textHeading }}</span>
            </template>
          </p>
          <p
            v-if="showIcon && textSubHeading && textSubHeading.length > 0"
            class="icon-text-sub-heading"
            v-bind:class="{'tab-step': tab && tab.showPaging}"
            @click="handleTabHeaderClick(tab)"
          >
            {{ textSubHeading }}
          </p>
        </div>
        <div class="tab-header-status">
          <template v-if="tab && tab.showPaging">
            <BPagination
              v-model="tab.currentPage"
              class="tab-step-container"
              size="sm"
              :total-rows="tab.totalRows"
              :per-page="1"
              @update:model-value="handleTabPagingClick(tab)"
            />
          </template>
          <template v-else-if="showIcon">
            <template v-if="iconStatus === 'DONE'">
              <AppIcon class="icon-done" name="check-circle-o" scale="1.2"></AppIcon>
            </template>
            <template v-else-if="iconStatus === 'PAUSE'">
              <AppIcon class="icon-pause" name="pause-circle-o" scale="1.2"></AppIcon>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <p class="icon-text-heading">
          <span>{{ textHeading }}</span>
          <template v-if="showIcon">
            <template v-if="iconStatus === 'DONE'">
              <AppIcon class="icon-done" name="check-circle-o"></AppIcon>
            </template>
            <template v-else-if="iconStatus === 'PAUSE'">
              <AppIcon class="icon-pause" name="pause-circle-o"></AppIcon>
            </template>
          </template>
          <AppIcon class="icon-arrow" v-bind:class="{ 'icon-rotate-90': showIcon}" name="angle-down" scale="1.2"></AppIcon>
        </p>
        <p class="icon-text-sub-heading" v-if="showIcon && textSubHeading && textSubHeading.length > 0">{{ textSubHeading }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import AppIcon from '@/components/AppIcon.vue';
import { BPagination } from 'bootstrap-vue-next';
import { EventBus } from '../../event-bus';
import {
  EVENT_TAB_ICON_RIGHT,
  EVENT_TAB_STEP_CLICK,
  EVENT_TAB_STEP_PAGING_CLICK
} from '../../store/events';
export default {
  data () {
    return {
      eventBusUnsubscribe: null
    };
  },
  props: {
    tab: {
      type: Object,
      default: () => {}
    },
    iconStatus: {
      type: String,
      default: ''
    },
    iconDoneRightPlace: {
      type: Boolean,
      default: () => false
    },
    showIcon: {
      type: Boolean,
      default: () => false
    },
    showPaging: {
      type: Boolean,
      default: () => false
    },
    textHeading: {
      type: String,
      default: () => ''
    },
    textSubHeading: {
      type: String,
      default: () => ''
    }
  },
  mounted () {
    this.eventBusUnsubscribe = EventBus.$on(EVENT_TAB_ICON_RIGHT, () => {
      this.$forceUpdate();
    });
  },
  beforeUnmount () {
    if (this.eventBusUnsubscribe) {
      this.eventBusUnsubscribe();
      this.eventBusUnsubscribe = null;
    }
  },
  components: {
    AppIcon,
    BPagination
  },
  methods: {
    handleTabHeaderClick (t) {
      this.$emit(EVENT_TAB_STEP_CLICK, t);
    },
    handleTabPagingClick (i) {
      this.$emit(EVENT_TAB_STEP_PAGING_CLICK, i);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .tab-icon-text-wrapper {
    height: 41px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .tab-header-layout {
    display: flex;
    align-items: center;
  }

  .tab-header-copy {
    display: flex;
    flex-direction: column;
  }

  .tab-header-status {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .icon-text-heading {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;

    &.inactive {
      color: #58666E;
    }
  }

  .icon-text-sub-heading {
    font-weight: 300;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .icon-text-heading,
  .icon-text-sub-heading {
    margin: 0;
    color: black;
  }

  .icon-arrow {
    color: black;
    margin-left: 50px;
  }

  .icon-done {
    color: #28a745;
  }

  .icon-pause {
    color: #ffc107;
  }

  .icon-rotate-90 {
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  .tab-step {
    min-width: 60px;
    width: 130px;
  }
</style>
